import React from "react";
import Card from "components/card";
import Button from "components/button";
import { 
    Target,
} from "lucide-react";
import SearchFilter from "components/search/SearchFilter";
import SelectOption from "components/select/SelectOption";
import { getIcon } from "variables/constants";
import JobFitCard from "./JobFitCard";

const RoleSourcing = ({ roles = [] }) => {

    const roleOptions = [
        { label: "All Roles", value: 0, code: "ALL" },
        { label: "Finance & Accounting", value: 1, code: "FINANCE" },
        { label: "Customer Service", value: 2, code: "CUSTOMER" },
        { label: "Admin & Legal", value: 3, code: "ADMIN" },
        { label: "Sales & Marketing", value: 4, code: "SALES" },
        { label: "Property & Facilities", value: 5, code: "PROPERTY" },
        { label: "Technology & IT", value: 6, code: "TECH" },
        { label: "Construction", value: 7, code: "CONSTRUCTION" },
        { label: "eCommerce & Retail", value: 8, code: "ECOMMERCE" },
    ].map(option => ({ ...option, icon: getIcon(option.code) }));

    const displayedRoles = roles;

    return (
        <Card className="p-0">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4">
                <h3 className="text-[16px] sm:text-[18px] font-semibold flex items-center gap-2 title-text">
                    <Target className="w-5 h-5 text-blue-600 dark:text-blue-500" />
                    Role Sourcing Intelligence
                </h3>
                <div className="flex items-center gap-2">
                    <span className="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 gap-1 title-text text-[11px]">
                        {73}  {"roles analyzed"}
                    </span>
                </div>
            </div>
            <div className="p-4 rounded-xl bg-gradient-to-br from-blue-50 to-indigo-50 border-2 border-blue-200 mb-4 dark:from-blue-900 dark:to-indigo-900">
                <div className="flex items-start gap-3">
                    <Target className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5 dark:text-blue-500" />
                    <div className="text-[12px] sm:text-[13px]">
                        <p className="font-semibold text-blue-900 dark:text-blue-50 mb-1">Role Sourcing Difficulty Guide</p>
                        <p className="text-blue-800 leading-relaxed mb-3 dark:text-blue-100">
                            This rating system indicates how easy it is to find qualified candidates for specific roles in Philippines. A higher rating (more stars) means abundant talent and easier sourcing.
                        </p>
                        <div className="bg-white/60 rounded-lg p-3 space-y-1.5">
                            <p className="font-semibold text-blue-900 mb-2">How to read the scale:</p>
                            <div className="space-y-1 text-blue-800 tracking-normal">
                                <p><span className="font-semibold">5 = Excellent fit </span>(easy to hire, easy to run, low friction)</p>
                                <p><span className="font-semibold">4 = Strong fit </span>(very workable with light enablement)</p>
                                <p><span className="font-semibold">3 = Viable </span>(very workable with light enablement)</p>
                                <p><span className="font-semibold">2 = Challenging </span>(niche or senior-only, higher oversight)</p>
                                <p><span className="font-semibold">1 = Poor fit </span>(generally not recommended offshore)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="space-y-2 mb-2">
                <SearchFilter 
                    placeholder="Search for a role..." 
                    searchHandler="" 
                    filters=""
                    pagination=""
                />
            </div>
            <div className="space-y-2 mb-4">
                <h3 className="text-[12px] sm:text-[13px] font-medium muted-text">Filter by category:</h3>
                <SelectOption
                    placeholder="Select department"
                    options={roleOptions}
                    showLabel={true}
                    showIcons={true}
                />
            </div>
            <div className="flex items-center gap-2 mb-4 flex-wrap">
                <span className="text-[12px] sm:text-[13px] font-medium muted-text">
                    Sort by:
                </span>
                <div className="flex gap-2 flex-wrap">
                    <Button className="access-button btn-default !px-3 !text-[11px] !sm:text-[12px] !h-8">Default</Button>
                    <Button className="access-button btn-default !px-3 !text-[11px] !sm:text-[12px] !h-8">Easiest First</Button>
                    <Button className="access-button btn-default !px-3 !text-[11px] !sm:text-[12px] !h-8">Challenging First</Button>
                    <Button className="access-button btn-default !px-3 !text-[11px] !sm:text-[12px] !h-8">A-Z</Button>
                </div>
            </div>
            <div className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border-2 border-blue-200 dark-mode-card">
                <div className="pb-6 p-4 sm:p-6">
                    <div className="relative h-[500px] sm:h-[600px]">
                        <div className=" size-full rounded-[inherit] transition-[color,box-shadow] outline-none overflow-y-auto">
                            <div className="space-y-3 pr-3">
                                {displayedRoles.map((role, index) => (
                                    <JobFitCard key={index} role={role} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default RoleSourcing;